// https://github.com/JonasKruckenberg/imagetools/blob/main/docs/directives.md
const images = import.meta.glob(
    '../../assets/images/blog/**/*.{avif,gif,heif,jpeg,jpg,png,tiff,webp,svg}',
    {
        eager: true,
        query: {
            enhanced: true,
            quality: 100,
            w: '600;800'
        }
    }
)
export const map = Object.entries(images).reduce(
    (map, [pathname, module]) => {
        const basename = pathname.slice(pathname.indexOf('blog/') + 'blog/'.length)
        map[basename] = module
        return map
    },
    {} as Record<string, any>
)